import { Stack, SxProps } from '@mui/material';
import { colors, Typography } from '@sweep-io/sweep-design';
import { ReactNode } from 'react';

interface SectionProps {
  children: ReactNode;
  headerTxt: string;
  withBorderBottom?: boolean;
  sx?: SxProps;
}

export const Section = ({ children, headerTxt, withBorderBottom, sx }: SectionProps) => (
  <Stack flexDirection="column" gap={1} sx={sx}>
    <Stack
      borderBottom={withBorderBottom ? `1px solid ${colors.grey[120]}` : ''}
      pb={withBorderBottom ? 1 : 0}
    >
      <Typography variant="caption-medium">{headerTxt}</Typography>
    </Stack>
    {children}
  </Stack>
);
